import {resolveBackground} from '#core/utils/color-utils.js';

import {BasicPalette} from '#core/application/modules/basic-palette.js';

export function maintenanceFactory(PALETTE) {
    return {
        MaintenanceView: {
            infoContainer: {
                style: {
                    ...resolveBackground(PALETTE.MAINTENANCE_BG),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '100vh',
                    width: '100%',
                    fontFamily: BasicPalette.palette.FONT_FAMILY,
                },
            },
            title: {
                style: {
                    ...PALETTE.MAINTENANCE_TITLE_TEXT,
                },
                container: {
                    marginBottom: '36px',
                    maxHeight: 'fit-content',
                },
            },
            text: {
                style: {
                    ...PALETTE.MAINTENANCE_INFO_TEXT,
                    maxWidth: '500px',
                },
                container: {
                    padding: '0 16px',
                    maxHeight: 'fit-content',
                },
            },
        },
    };
}
